module.exports = __webpack_public_path__ + "img/kabir_2.89ecae07.jpg";